import type { Area } from '@common/types/Area'
import type { Poi } from '@common/types/Poi'
import type { Stop } from '@common/types/Stop'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import type { MultiPolygon, Point, Polygon } from 'geojson'
import { useMemo } from 'react'

export function useObjectsInGeojson<T extends Poi | Stop | Area>(
	objects: T[],
	geojson?: Polygon | MultiPolygon,
): T[] {
	const objectsInGeojson = useMemo(
		() =>
			geojson
				? [
						...new Set(
							objects.filter(object => {
								return booleanPointInPolygon(
									(object.geojson as Point).coordinates,
									geojson,
								)
							}),
						),
					]
				: objects,
		[objects, geojson],
	)

	return objectsInGeojson
}
